import React from "react";
import type {useInstrumentPageHook} from "./useInstrumentPageHook";


export const InstrumentPageContext = React.createContext<ReturnType<typeof useInstrumentPageHook> | null>(null);
